<template>
  <div v-if="location">
    <base-header type="gradient-success" />
    <div class="container-fluid mt--6">
      <!-- card: location details -->
      <card shadow type="secondary" class="mb-4" noBody>
        <template v-slot:header>
          <div class="bg-white border-0">
            <div class="mb-3">
              <router-link to="/locations" class="text-sm text-muted">
                <i class="ni ni-bold-left mr-1"></i>Back to all locations
              </router-link>
            </div>
            <div class="row align-items-start">
              <div class="col">
                <h3 class="mb-0">{{ name }}</h3>
                <div v-if="address">{{ address }}</div>
                <div v-if="timezone" class="text-muted text-sm">
                  {{ timezone }}
                </div>
                <small class="linkcopy text-muted" @click="copy(locationId)">{{
                  locationId
                }}</small>
              </div>
              <div class="col-auto">
                <button class="btn btn-sm btn-primary" @click="openEditModal">
                  Edit
                </button>
              </div>
            </div>
          </div>
        </template>
        <!-- <div class="mb-5">Default tip amount $5.00</div> -->
      </card>

      <!-- Edit Location Modal -->
      <modal :show="showEditModal" @close="closeEditModal">
        <template v-slot:header>
          <h5 class="modal-title">Edit Location</h5>
        </template>
        <form @submit.prevent="saveLocation">
          <div class="form-group">
            <label class="form-control-label">Name</label>
            <input
              type="text"
              v-model="editForm.name"
              class="form-control form-control-alternative"
              placeholder="Location name"
              required
            />
          </div>
          <div class="form-group">
            <label class="form-control-label">Address</label>
            <input
              type="text"
              v-model="editForm.address"
              class="form-control form-control-alternative"
              placeholder="Address"
              required
            />
          </div>
          <div class="form-group">
            <label class="form-control-label">Timezone</label>
            <select
              v-model="editForm.timezone"
              class="form-control form-control-alternative"
              required
            >
              <option value="">Select timezone</option>
              <option value="US/Eastern">Eastern (US/Eastern)</option>
              <option value="US/Central">Central (US/Central)</option>
              <option value="US/Mountain">Mountain (US/Mountain)</option>
              <option value="US/Pacific">Pacific (US/Pacific)</option>
              <option value="US/Alaska">Alaska (US/Alaska)</option>
              <option value="US/Hawaii">Hawaii (US/Hawaii)</option>
            </select>
          </div>
        </form>
        <template v-slot:footer>
          <button
            type="button"
            class="btn btn-secondary"
            @click="closeEditModal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="saveLocation"
            :disabled="
              !editForm.name || !editForm.address || !editForm.timezone
            "
          >
            Save Changes
          </button>
        </template>
      </modal>

      <!-- card: Tip Stat Page -->
      <TipStatPage :location="location" />

      <!-- card: manage links -->
      <LocationLeadership
        :location="location"
        @updated="(l) => (location = l)"
      />
      <ExternalLinks :location="location" @updated="(l) => (location = l)" />
      <DayforceIntegration
        :location="location"
        @updated="(l) => (location = l)"
      />

      <!-- card: qr codes -->
      <card class="mb-4" shadow noBody>
        <template v-slot:header>
          <div class="bg-white border-0">
            <div class="row align-items-top">
              <div class="col-8">
                <h3 class="mb-0">QR Codes</h3>
              </div>
              <div class="col-4 text-right">
                <!-- <a href="#!" @click.prevent="$router.go(-1)" class="btn btn-sm btn-primary">add new</a> -->
              </div>
            </div>
          </div>
        </template>
        <div class="table-responsive">
          <base-table thead-classes="thead-light" :data="codes">
            <template v-slot:columns>
              <th>Label</th>
              <th>Code</th>
              <th>Status</th>
              <th>Created</th>
              <th></th>
            </template>

            <template v-slot:default="row">
              <td>
                {{ row.item.label }}
              </td>
              <th scope="row">
                {{ row.item.code }}
              </th>
              <td>
                {{ row.item.status }}
              </td>
              <td>
                {{ row.item.created }}
              </td>
              <td>
                <a
                  href="#"
                  @click.prevent="downloadCode(row.item)"
                  class="btn btn-sm btn-info"
                  >download</a
                >
                <a
                  href="#"
                  @click.prevent="copyCodeUrl(row.item)"
                  class="btn btn-sm btn-info"
                  >copy url</a
                >
                <a
                  href="#"
                  @click.prevent="openCodeUrl(row.item)"
                  class="btn btn-sm btn-info"
                  >view url</a
                >
              </td>
            </template>
          </base-table>
        </div>
      </card>

      <LocationTips :location="location" />

      <!-- card: tips -->
      <!-- <card class="mb-4" shadow noBody>
        <template v-slot:header>
          <div class="bg-white border-0">
            <div class="row align-items-top">
              <div class="col-8">
                <h3 class="mb-0">Tips</h3>
              </div>
              <div class="col-4 text-right">
              </div>
            </div>
          </div>
        </template>
        <div class="table-responsive">
          <base-table thead-classes="thead-light" :data="tips">
            <template v-slot:columns>
              <th>Tip</th>
              <th>Fee</th>
              <th>Total</th>
              <th>Code</th>
              <th>Created</th>
              <th></th>
            </template>
            <template v-slot:default="row">
              <th scope="row">
                {{ row.item.tip }}
              </th>
              <td>
                {{ row.item.fee }}
              </td>
              <td>
                {{ row.item.amount }}
              </td>
              <td>
                {{ row.item.code }}
              </td>
              <td>
                {{ row.item.ts }}
              </td>
              <td>
                <a
                  href="#"
                  @click.prevent="openUrl(row.item.receipt_url)"
                  class="btn btn-sm btn-info"
                  >view receipt</a
                >
              </td>
            </template>
          </base-table>
        </div>
      </card> -->
    </div>
  </div>
</template>
<script>
import QRCode from "qrcode";
import copy from "copy-to-clipboard";

import Modal from "@/components/Modal";
import TipStatPage from "@/components/TipStatPage";
import LocationLeadership from "@/components/LocationLeadership";
import ExternalLinks from "@/components/ExternalLinks";
import DayforceIntegration from "@/components/DayforceIntegration";
import LocationTips from "@/components/LocationTips";

export default {
  mounted() {
    this.fetchLocation(this.$route.params.locationId);
  },
  components: {
    Modal,
    TipStatPage,
    LocationLeadership,
    ExternalLinks,
    DayforceIntegration,
    LocationTips,
  },
  data() {
    return {
      isLoading: true,
      location: false,
      qrOpts: {
        errorCorrectionLevel: "Q",
      },
      tips: [],
      tripAdvisor: "",
      googleReview: "",
      showEditModal: false,
      editForm: {
        name: "",
        address: "",
        timezone: "",
      },
    };
  },
  computed: {
    locationId() {
      return this.$route.params.locationId || "";
    },
    name() {
      return this.location.name || "";
    },
    address() {
      return this.location.address || "";
    },
    timezone() {
      return this.location.timezone || "";
    },
    codes() {
      return this.location.codes || [];
    },
    tipUrl() {
      return `https://${process.env.VUE_APP_TIP_DOMAIN}`;
    },
  },
  methods: {
    async fetchLocation(locationId) {
      const response = await this.$store.dispatch("callAPI", {
        action: "getLocation",
        locationId: locationId,
      });
      this.location = response.data.data;
      this.isLoading = false;
    },
    openEditModal() {
      this.editForm.name = this.location.name || "";
      this.editForm.address = this.location.address || "";
      this.editForm.timezone = this.location.timezone || "";
      this.showEditModal = true;
    },
    closeEditModal() {
      this.showEditModal = false;
    },
    async saveLocation() {
      const response = await this.$store.dispatch("callAPI", {
        action: "updateLocation",
        locationId: this.location.locationId,
        name: this.editForm.name,
        address: this.editForm.address,
        timezone: this.editForm.timezone,
      });
      this.location = response.data.data;
      this.showEditModal = false;
    },
    async downloadCode(code) {
      QRCode.toDataURL(
        `${this.tipUrl}/${code.code}`,
        this.qrOpts,
        function (err, url) {
          const link = document.createElement("a");
          link.href = url;
          link.download = code.code;
          link.click();
        }
      );
    },
    copy(data) {
      copy(data);
    },
    async copyCodeUrl(code) {
      copy(`${this.tipUrl}/${code.code}`);
    },
    async openCodeUrl(code) {
      this.openUrl(`${this.tipUrl}/${code.code}`);
    },
    async openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss">
.linkcopy {
  cursor: pointer;
}
</style>
